import { type FC, useMemo } from "react";
import { Link } from "react-router-dom";
import { type NavigationType } from "./Navigation";

interface Props {
    name: string;
    group: string;
    isSelected: boolean;
    item: number | NavigationType;
}

export const NavigationItem: FC<Props> = ({
    name,
    group,
    isSelected,
    item,
}) => {
    const itemPath = name.replace(/ /g, "-");

    const children = useMemo(() => {
        if(typeof item === "number") {
            return [];
        }

        const results: Array<string> = [];

        for(const key in item) {
            if(!(key in item)) {
                continue;
            }

            if(key === "_link") {
                continue;
            }

            results.push(key);
        }

        return results;
    }, [ item ]);

    return (
        <li className="w-full box-border">
            <Link
                title={name}
                to={`/documentation/${group}/${itemPath}`}
                className={
                    "text-sm block box-border w-full px-12 py-1 no-underline " +
                    "rounded cursor-pointer truncate font-normal " +
                    "hover:bg-neutral-300 " + (
                        isSelected ?
                            "text-sky-700" :
                            "text-black "
                    )
                }
            >
                {name}
            </Link>
            {children.length > 0 && (
                <ul className="list-none text-sm mb-2 mt-1 space-y-1 p-0">
                    {children.map(child => (
                        <li key={child}>
                            <Link
                                title={child}
                                to={`/documentation/${group}/${itemPath}#${child.replace(/ /g, "-")}`}
                                className={
                                    "text-sm block box-border w-full pl-16 pr-12 no-underline rounded cursor-pointer " +
                                    "truncate font-normal text-neutral-700 hover:bg-neutral-300"
                                }
                            >
                                {child}
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </li>
    );
};
